export default {
    "welcome": {
        "title": "Benvenuto in ProcrastiQ",
        "subtitle": "Il tuo compagno di produttività",
        "modal": {
            "title": "Benvenuto in ProcrastiQ",
            "headline": "Pause intelligenti per il tuo cervello",
            "subheading": "Snack per il cervello, curiosità e momenti consapevoli che trasformano minuti liberi in qualcosa di significativo.",
            "text": "Procrastiq è il luogo dove la procrastinazione diventa qualcosa di significativo. Invece di scorrere all'infinito sui social media, scoprirai veloci snack per il cervello progettati per intrattenere, stimolare la mente e magari insegnarti qualcosa di nuovo.\n\nNon si tratta affatto di produttività a tutti i costi. Tutti hanno bisogno di un momento per fermarsi, ricaricarsi e allontanarsi dal lavoro. Procrastiq ti aiuta a trasformare quelle piccole pause in qualcosa di positivo — piene di curiosità, divertimento e allenamento quotidiano della mente. Piccole sfide. Grandi progressi.",
            "cta": "Andiamo"
        }
    },
    "login": {
        "title": "Accedi",
        "email": "Email",
        "password": "Password",
        "submit": "Accedi",
        "cancel": "Annulla",
        "success": "Accesso riuscito",
        "lead": "Bentornato — riprendi la tua serie di successi e scala le classifiche."
    },
    "logout": "Esci",
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Pause intelligenti per il tuo cervello"
    },
    "register": {
        "title": "Registrati",
        "name": "Nome",
        "email": "Email",
        "password": "Password",
        "submit": "Crea account",
        "cancel": "Annulla",
        "success": "Registrazione riuscita",
        "country": "Paese",
        "lead": "Crea un account per guadagnare XP, sbloccare ranghi e partecipare alle leghe settimanali."
    },
    "social": {
        "divider": "Oppure continua con",
        "signInWith": "Accedi con {{provider}}",
        "continueWith": "Continua con {{provider}}",
        "failed": "Accesso social fallito",
        "popup_blocked": "Il popup è stato bloccato. Per favore, permetti i popup e riprova.",
        "cancelled": "Accesso annullato."
    },
    "common": {
        "cancel": "Annulla",
        "saving": "Salvataggio in corso...",
        "unknown_error": "Errore sconosciuto",
        "select_country": "Seleziona il paese",
        "select_option": "Seleziona un'opzione",
        "country": "Paese"
    },
    "language": {
        "page_language": "Lingua della pagina",
        "switch_to": "Passa a {{language}}"
    },
    "cookies": {
        "title": "Cookie",
        "message": "Usiamo cookie di analitica (Google Analytics) per migliorare Procrastiq.",
        "privacy_link": "Informativa sulla privacy",
        "accept": "Accetta",
        "reject": "Rifiuta"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "Chi siamo",
                "mission": "Missione",
                "progression": "XP, livelli e leghe",
                "creator_progression": "XP dei creatori e ranghi",
                "contact": "Contattaci"
            },
            "leaderboards": {
                "title": "Classifiche",
                "players": "Membri",
                "creators": "Contributori"
            },
            "legal": {
                "title": "Privacy e Termini",
                "community": "Linee guida della community",
                "terms": "Termini di servizio",
                "privacy": "Informativa sulla privacy"
            },
            "social": {
                "title": "Social",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Missione",
            "content": "ProcrastiQ trasforma piccole pause in momenti significativi — snack per il cervello, enigmi e pause consapevoli che intrattengono e stimolano la mente. \n\nCrediamo che la procrastinazione non debba essere tempo sprecato. Tutti meritano un momento per ricaricarsi, e noi aiutiamo a rendere quei momenti positivi, curiosi e divertenti. "
        },
        "contact": {
            "title": "Contattaci",
            "content": "Hai una domanda, un’idea di miglioramento o hai trovato qualcosa che non funziona come dovrebbe? Scrivici: ogni feedback ci aiuta a migliorare Procrastiq.\n\nPuoi scriverci a:\n\nhello@procrastiq.com\n\nCi farà piacere leggere anche i tuoi suggerimenti su nuovi contenuti, funzionalità o temi che vorresti vedere su Procrastiq."
        },
        "community": {
            "title": "Linee guida della comunità",
            "content": "ProcrastiQ è uno spazio accogliente per menti curiose. Sii rispettoso, gentile e costruttivo nelle tue interazioni. \n\nNon pubblicare contenuti dannosi, abusivi o spam. Segnala tutto ciò che non appartiene. Insieme manteniamo questo un luogo positivo per imparare e fare pause intelligenti. "
        },
        "terms": {
            "title": "Termini di servizio",
            "content": "**Ultimo aggiornamento: 7 settembre 2026**\n\nUtilizzando il servizio Procrastiq accetti i presenti termini. Se non sei d’accordo, ti preghiamo di non utilizzare il servizio.\n\n## 1. Informazioni su Procrastiq\n\nProcrastiq è una piattaforma online dedicata all’apprendimento, ai quiz, agli enigmi e ad altri contenuti interattivi.\n\nI contenuti del servizio sono destinati principalmente all’istruzione e all’intrattenimento. Non costituiscono consulenza professionale, legale, medica, finanziaria o di altro tipo specialistico.\n\n## 2. Account utente\n\nAlcune funzionalità di Procrastiq possono richiedere la creazione di un account utente.\n\nSei responsabile dell’accuratezza delle informazioni del tuo account e della sicurezza delle tue credenziali di accesso.\n\nUn account non deve essere usato per violare i diritti di terzi, la legge applicabile o i presenti termini.\n\n## 3. Regole di utilizzo\n\nNell’uso di Procrastiq non è consentito, in particolare:\n\n* pubblicare contenuti illegali, fraudolenti, di odio o altrimenti dannosi,\n* violare diritti d’autore o altri diritti di terzi,\n* molestare altri utenti,\n* tentare di compromettere la sicurezza o il funzionamento del servizio,\n* raccogliere automaticamente contenuti o dati in modi che non consentiamo,\n* abusare di valutazioni, XP, classifiche o altri meccanismi di gioco.\n\n## 4. Contenuti degli utenti\n\nGli utenti possono creare o inviare contenuti propri, ad esempio quiz, domande, commenti o altri contributi.\n\nInviando contenuti, confermi di avere il diritto di pubblicarli.\n\nConservi i tuoi diritti sui tuoi contenuti. Allo stesso tempo, ci concedi un diritto non esclusivo di memorizzarli, mostrarli, adattarli tecnicamente e renderli disponibili all’interno di Procrastiq nella misura necessaria per gestire il servizio.\n\n## 5. Moderazione dei contenuti\n\nPossiamo esaminare i contenuti degli utenti e, in caso di violazione dei presenti termini o della legge applicabile, rifiutarli, nasconderli o rimuoverli.\n\nNei casi gravi o ripetuti, possiamo limitare o chiudere un account utente.\n\nQuando le circostanze lo consentono e la legge lo richiede, informiamo l’utente del motivo di tale decisione.\n\n## 6. Contenuti Procrastiq\n\nI contenuti pubblicati direttamente da Procrastiq possono contenere errori o imprecisioni. Sebbene cerchiamo di verificare e migliorare continuamente le informazioni, non possiamo garantirne la completezza o l’assenza di errori.\n\nI quiz e altri contenuti educativi hanno principalmente carattere informativo e ricreativo.\n\n## 7. Disponibilità del servizio\n\nCi impegniamo a mantenere Procrastiq disponibile e funzionante, ma non possiamo garantire un funzionamento ininterrotto o privo di errori.\n\nPossiamo modificare, ampliare o interrompere parti del servizio nel tempo.\n\n## 8. Responsabilità\n\nNella misura consentita dalla legge applicabile, non siamo responsabili dei danni derivanti dall’uso improprio del servizio o dall’affidamento su contenuti di carattere meramente informativo o educativo.\n\nCiò non pregiudica i diritti degli utenti che non possono essere limitati ai sensi della legge applicabile.\n\n## 9. Privacy\n\nLe informazioni su come trattiamo i dati personali sono disponibili nella nostra [Informativa sulla privacy](/legal/privacy).\n\n## 10. Modifiche ai presenti termini\n\nPossiamo aggiornare questi termini di tanto in tanto, ad esempio a causa di cambiamenti del servizio, della normativa o del funzionamento di Procrastiq.\n\nLa data dell’ultimo aggiornamento sarà sempre indicata in alto in questa pagina. Possiamo anche informare gli utenti di modifiche rilevanti tramite il servizio o via e-mail.\n\n## 11. Contatti\n\nPer domande su questi termini, puoi contattarci a:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Informativa sulla privacy",
            "content": "**Ultimo aggiornamento: 7 settembre 2026**\n\nPrendiamo sul serio la tua privacy. Di seguito spieghiamo quali dati personali trattiamo quando usi Procrastiq, perché ne abbiamo bisogno e quali diritti hai.\n\n## 1. Chi tratta i dati\n\nIl titolare del trattamento dei dati personali è:\n\n**Michal Orlík**\npersona fisica\n\nContatto per domande sulla protezione dei dati personali:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Quali dati trattiamo\n\nA seconda di come usi Procrastiq, possiamo trattare in particolare:\n\n* i dati del tuo account, ad esempio nome, nome utente e indirizzo e-mail,\n* i dati ottenuti al momento dell'accesso tramite un servizio esterno, ad esempio Google,\n* informazioni sull'uso del servizio, ad esempio contenuti visualizzati, risultati dei quiz, XP ottenuti, streak, reazioni, segnalibri e attività nel feed,\n* contenuti che crei o invii tu stesso,\n* dati tecnici, ad esempio indirizzo IP, tipo di dispositivo, browser e informazioni necessarie per la sicurezza e il corretto funzionamento del servizio.\n\n## 3. Perché usiamo i dati\n\nUsiamo i dati personali principalmente per:\n\n* creare e gestire il tuo account,\n* fornire le funzionalità di Procrastiq,\n* salvare i tuoi progressi, risultati, XP e altra attività,\n* personalizzare contenuti e raccomandazioni,\n* proteggere il servizio da abusi,\n* risolvere errori e problemi tecnici,\n* comunicare con te,\n* analizzare e migliorare il funzionamento del servizio.\n\n## 4. Base giuridica del trattamento\n\nTrattiamo i dati secondo ciascuna finalità principalmente:\n\n* perché sono necessari per fornire il servizio,\n* sulla base del nostro legittimo interesse alla sicurezza e al miglioramento di Procrastiq,\n* sulla base del tuo consenso laddove il consenso è richiesto,\n* oppure per adempiere obblighi di legge.\n\nSe il trattamento si basa sul consenso, puoi revocarlo in qualsiasi momento.\n\n## 5. A chi possono essere comunicati i dati\n\nNon vendiamo i tuoi dati personali.\n\nPer far funzionare il servizio, tuttavia, possiamo utilizzare fornitori esterni, ad esempio per:\n\n* hosting e infrastruttura,\n* autenticazione degli utenti,\n* invio di e-mail e notifiche,\n* analitica e diagnostica degli errori.\n\nQuesti fornitori possono trattare i dati solo nella misura necessaria a fornire i propri servizi.\n\n## 6. Per quanto tempo conserviamo i dati\n\nI dati collegati al tuo account sono generalmente conservati per la durata dell'account e successivamente per il tempo necessario a rispettare obblighi di legge o tutelare i nostri legittimi interessi.\n\nI dati tecnici e analitici sono conservati solo per il tempo necessario alla loro finalità.\n\n## 7. I tuoi diritti\n\nIn relazione al trattamento dei dati personali, a seconda delle circostanze hai il diritto di:\n\n* ottenere informazioni su quali dati trattiamo su di te,\n* chiedere la rettifica di dati inesatti,\n* chiedere la cancellazione dei dati,\n* chiedere la limitazione del trattamento,\n* opporti ad alcune modalità di trattamento,\n* ricevere i tuoi dati in un formato portabile,\n* revocare il consenso prestato.\n\nPuoi inviare una richiesta a:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nRispondiamo alle richieste in conformità alla normativa applicabile.\n\n## 8. Eliminazione dell'account\n\nSe il servizio consente l'eliminazione dell'account, puoi richiederne la rimozione direttamente nelle impostazioni dell'account o contattarci a **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nCon l'eliminazione dell'account rimuoviamo o anonimizziamo i dati personali che non dobbiamo più conservare per motivi giuridici o di sicurezza.\n\n## 9. Cookie e tecnologie simili\n\nProcrastiq può utilizzare cookie e tecnologie simili necessari per l'accesso, la sicurezza, il salvataggio delle impostazioni e, eventualmente, l'analitica.\n\nInformazioni più dettagliate sui cookie possono essere riportate in un'informativa cookie separata.\n\n## 10. Sicurezza\n\nUtilizziamo misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita o uso improprio.\n\nNessun sistema può tuttavia essere considerato assolutamente sicuro.\n\n## 11. Reclamo\n\nSe ritieni che trattiamo i tuoi dati personali in violazione della normativa applicabile, puoi anche rivolgerti all'autorità di controllo competente.\n\nNella Repubblica Ceca è l'**Ufficio per la protezione dei dati personali (Úřad pro ochranu osobních údajů)**.\n\n## 12. Modifiche a questa informativa\n\nPossiamo aggiornare questa informativa di tanto in tanto, ad esempio in relazione a nuove funzionalità o a modifiche normative.\n\nLa data dell'ultimo aggiornamento sarà sempre indicata nella parte superiore di questa pagina."
        },
        "progression": {
            "title": "XP, livelli e leghe",
            "content": "ProcrastiQ premia la curiosità. Rispondi ai quiz, costruisci serie e sali da snack casuali al cervello a competizione settimanale. \n\n## Punti esperienza (XP)\n\nGuadagni XP permanente quando giochi bene — ad esempio risposte corrette, bonus al primo tentativo, domande più difficili, recensioni e obiettivi giornalieri. L'XP permanente non si resetta mai e conta sempre per il tuo livello. \n\nEsiste anche XP classificato usato solo per le leghe settimanali. L'XP classificata usa rendimenti decrescenti giornalieri: l'XP iniziale della giornata conta completamente, i guadagni successivi contano meno. Questo mantiene la competizione equa se qualcuno gioca tutto il giorno. \n\n## Livelli\n\nIl tuo livello deriva dall'XP totale permanente. Ogni livello richiede un po' più di XP rispetto al precedente (una curva di crescita), quindi il progresso rimane significativo.\n\nIl tuo profilo mostra quanta esperienza hai nel livello attuale e quanta ti serve per il prossimo. \n\n## Gradi del titolo\n\nI gradi sono titoli sbloccati per livello. Sono un distintivo di quanto sei arrivato — separato dai livelli settimanali della lega. \n\n- Livello 1 — Mente Curiosa\n- Livello 3 — Esploratore\n- Livello 5 — Ricercatore\n- Livello 8 — Risolutore di problemi\n- Livello 12 — Analista\n- Livello 18 — Logico\n- Livello 25 — Stratega\n- Livello 35 — Polimata\n- Livello 50 — Genio\n- Livello 70 — Maestro della Conoscenza\n- Livello 100 — Procrastiq Leggenda\n\n## Leghe settimanali\n\nLe leghe sono una competizione settimanale con altri giocatori in gruppi di circa 20 persone. \n\nLivelli dal più basso al più alto: \n\n- Ferro\n- Bronzo\n- Argento\n- Oro\n- Platino\n- Diamante\n- Maestro\n- Leggendario\n\nOgni settimana gareggi con XP classificato all'interno del tuo gruppo. Alla fine della settimana, approssimativamente i giocatori più avanti promuovono un livello e quelli più bassi retrocedono un livello. Tutti gli altri restano. \n\nNon devi aspettare il reset del lunedì per unirti. Quando diventi idoneo, vieni subito inserito in un gruppo aperto — oppure viene creato un nuovo gruppo per te. \n\nPer sbloccare leghe generalmente ti servono: \n\n- almeno 100 XP permanenti\n- almeno 10 attività completate\n- attività in almeno 2 giorni diversi\n- visibilità delle classifiche attivata per il tuo profilo\n\nApri la pagina delle Classifiche o il pannello delle statistiche in qualsiasi momento per vedere il tuo livello, posizione e gruppo. "
        },
        "creator_progression": {
            "title": "XP del creatore e gradi",
            "content": "Creare contenuti su ProcrastiQ ha una sua progressione — completamente separata dall'XP dei giocatori, dai livelli e dalle leghe settimanali. \n\nQuando le persone si godono i tuoi quiz e i tuoi snack mentali, guadagni XP Creator (CXP). CXP sblocca i gradi creator e ti posiziona nelle classifiche dei Contributori. \n\n## Due sistemi indipendenti\n\n- Progressione del giocatore — XP da gioco, livelli, classifiche per il titolo, leghe settimanali\n- Progressione dei creatori — CXP dal contributo di contenuti di qualità, classifiche dei creatori, bacheche dei Contributori\n\nGiocare non aumenta il tuo rango di creatore. Creare non aumenta il livello del giocatore. Puoi crescere in entrambi i brani contemporaneamente. \n\n## Come guadagni XP di Creator\n\nIl CXP viene assegnato per i contributi approvati e per l'interazione su quei contenuti — non per quante bozze si inviano.\n\nRicompense tipiche:\n\n- Contenuto approvato — +20 CXP (una volta per elemento)\n- Ogni 10 completamenti sul tuo contenuto — +2 CXP\n- Ogni 10 like sul tuo contenuto — +5 CXP\n- Ogni 10 segnalibri sul tuo contenuto — +2 CXP\n\nVisualizzazioni e altre statistiche vengono registrate sul tuo profilo creatore, ma solo le ricompense sopra riportate danno CXP. I valori possono essere regolati nel tempo.\n\n## Gradi dei creatori\n\nIl tuo grado di creatore deriva dal CXP totale. Le soglie crescono approssimativamente in modo esponenziale, quindi i progressi iniziali sembrano rapidi e i gradi più alti restano significativi.\n\n- 0 CXP — Collaboratore\n- 50 CXP — Creatore\n- 150 CXP — Autore\n- 400 CXP — Esperto\n- 1.000 CXP — Mentore\n- 2.500 CXP — Creatore Master\n- 6.000 CXP — Saggio Procrastiq\n\nIl tuo profilo mostra il grado attuale, il CXP e i progressi verso il grado successivo.\n\n## Classifiche dei collaboratori\n\nI creatori sono classificati in base al Creator XP, non al numero di contenuti inviati.\n\n- Settimanale — CXP guadagnato questa settimana\n- Mensile — CXP guadagnato questo mese\n- Tutto il tempo — CXP totale\n\nApri le classifiche e passa a Collaboratori per vedere chi sta scalando."
        }
    },
    "account": {
        "profile_picture": "Immagine del profilo",
        "save_changes": "Salva modifiche",
        "update_success": "Profilo aggiornato con successo",
        "update_failed": "Aggiornamento profilo fallito",
        "country": "Paese",
        "avatar": {
            "upload_label": "Carica avatar",
            "upload_success": "Avatar caricato con successo",
            "upload_failed": "Caricamento avatar fallito",
            "delete_confirm": "Sei sicuro di voler eliminare il tuo avatar?",
            "delete_success": "Avatar eliminato con successo",
            "delete_failed": "Eliminazione avatar fallita"
        },
        "password": {
            "set_optional": "Imposta password (Opzionale)",
            "change_optional": "Cambia password (Opzionale)",
            "oauth_info": "Hai effettuato l'accesso con {{method}}. Puoi facoltativamente impostare una password per abilitare l'accesso e-mail/password.",
            "current": "Password corrente",
            "current_placeholder": "Inserisci la password corrente",
            "current_required": "La password corrente è richiesta per cambiare password",
            "new": "Nuova password",
            "set_placeholder": "Imposta una password",
            "leave_blank_placeholder": "Lascia vuoto per mantenere quella attuale",
            "confirm": "Conferma nuova password",
            "confirm_placeholder": "Conferma nuova password",
            "mismatch": "Le nuove password non corrispondono"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "memory": "Memoria",
            "focus": "Focus",
            "sequence": "Sequenza",
            "reflex": "Riflesso"
        },
        "memory": {
            "hint_preview": "Ricorda le caselle evidenziate.",
            "hint_input": "Tocca le caselle che ricordi.",
            "cell": "Casella {{n}}"
        },
        "focus": {
            "hint": "Trova il simbolo diverso."
        },
        "sequence": {
            "title": "Ricorda la sequenza",
            "countdown_hint": "Preparati — la sequenza sta per iniziare.",
            "go": "Via!",
            "hint_watch": "Guarda attentamente.",
            "hint_input": "Ora ripeti la sequenza."
        },
        "reflex": {
            "hint": "Scegli il colore, non la parola.",
            "progress": "{{current}} / {{total}}"
        },
        "colors": {
            "red": "ROSSO",
            "blue": "BLU",
            "green": "VERDE",
            "orange": "ARANCIONE"
        },
        "result": {
            "success": "Ottimo!",
            "fail": "✗ Sbagliato."
        }
    },

    "pause": {
        "label": "Pausa",
        "types": {
            "breathing": "Respiro",
            "eyes": "Pausa occhi",
            "stretch": "Stretch rapido",
            "grounding": "Reset"
        },
        "skip": "Salta",
        "continue": "Continua",
        "breathing": {
            "inhale": "Inspira",
            "exhale": "Espira"
        },
        "eyes": {
            "step_far": "Guarda qualcosa piu lontano dallo schermo.",
            "step_blink": "Rilassa gli occhi e lampeggia lentamente alcune volte.",
            "step_close": "Chiudi gli occhi per un momento."
        },
        "stretch": {
            "step_shoulders": "Abbassa le spalle e lasciale rilassare.",
            "step_sit": "Siediti un po piu dritto e rilassa la schiena.",
            "step_roll": "Ruota lentamente le spalle."
        },
        "grounding": {
            "prompt_color": "Trova 3 cose intorno a te dello stesso colore.",
            "prompt_sounds": "Nota 2 suoni diversi intorno a te.",
            "prompt_look_away": "Distogli lo sguardo dallo schermo per qualche secondo.",
            "prompt_texture": "Tocca qualcosa vicino e nota la texture.",
            "prompt_breath": "Fai un respiro lento e senti i piedi a terra.",
            "prompt_feet": "Premi dolcemente i piedi a terra e senti il contatto."
        },
        "result": {
            "done": "Fatto"
        }
    },

    "content": {
        "loading": "Caricamento in corso...",
        "no_content": "Nessun contenuto ancora.",
        "feed_exhausted_tag": "Hai già risposto a tutto per questo tag",
        "feed_exhausted_category": "Hai già risposto a tutto per questa categoria",
        "browse_feed": "Sfoglia feed dei contenuti",
        "back_to_feed": "← Torna al feed",
        "back": "← Indietro",
        "content_not_found": "Contenuto non trovato",
        "failed_load": "Non è riuscito a caricare i contenuti",
        "failed_load_more": "Non sono riusciti a caricarne altri",
        "list": {
            "showing": "Mostrando {{count}} di {{total}}",
            "load_more": "Carica ancora"
        },
        "answer": {
            "your_answer": "La tua risposta... ",
            "your_result_or_answer": "Il tuo risultato o risposta... ",
            "select_or_type": "Scegli la risposta... ",
            "fill_in_blank": "Completa lo spazio... ",
            "your_answer_flip": "La tua risposta (o gira per controllare)... ",
            "reveal_answer": "Risposta rivelata",
            "self_check_prompt": "Lo sapevi? ",
            "knew_it": "Lo sapevo",
            "need_practice": "Ho bisogno di più pratica",
            "check": "Controllo",
            "completed": "Completato",
            "completing": "Salvando... ",
            "skip": "Skip",
            "next": "Prossimo",
            "checking": "Controlla... ",
            "correct": "✓ Corretto! ",
            "not_quite": "✗ Non proprio. ",
            "correct_answer": "Risposta corretta: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Accedi per mettere mi piace o non mettere mi piace",
            "bookmark": "Segnalibro",
            "remove_bookmark": "Rimuovi il segnalibro",
            "save_for_later": "A parte per più tardi",
            "saved": "Salvata",
            "share": "Condividi",
            "link_copied": "Link copiato sulla cartellina",
            "share_failed": "Non sono riuscito a condividere questo quiz",
            "completions": "Completamento: {{count}}",
            "aria_like": "Tipo",
            "aria_dislike": "Non mi piace"
        },
        "admin": {
            "edit": "Modifica",
            "delete": "Elimina",
            "stats": "Statistiche",
            "stats_title": "Statistiche del contenuto",
            "delete_confirm": "Eliminare \"{{title}}\"?",
            "deleted": "Contenuto eliminato",
            "delete_failed": "Impossibile eliminare il contenuto",
            "load_failed": "Impossibile caricare il contenuto",
            "id": "ID",
            "slug": "Slug",
            "status": "Stato",
            "locale": "Lingua",
            "likes": "Mi piace",
            "dislikes": "Non mi piace",
            "completions": "Completamenti",
            "open_in_admin": "Apri in admin"
        },
        "difficulty": {
            "label": "Difficoltà: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "La difficoltà {{value}} fuori {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Accedi per rispondere a questa domanda. ",
            "duration": "Durata: {{minutes}} min",
            "phase": "Fase {{number}}"
        },
        "list_item": {
            "completions": "{{count}} completamento",
            "completions_label": "Completamento: {{count}}"
        },
        "feed": {
            "success": "Corretto! 🎉",
            "skip": "Skip",
            "next": "Prossimo",
            "intro_gate": {
                "title": "Accedi per continuare",
                "body": "Accedi o crea un account e Procrastiq inizierà ad adattarsi a ciò che ti piace.",
                "body_more": "Non ripeterà inutilmente le stesse domande, ricorderà i tuoi risultati e ti offrirà contenuti in base ai tuoi interessi.",
                "perks": "Otterrai anche accesso a XP, leghe, Survival, sfide con altri giocatori e altre funzioni.",
                "register": "Crea account",
                "login": "Accedi"
            }
        }
    },
    "categories": {
        "title": "Categorie",
        "filter": "Filtra per categoria",
        "all": "Tutti",
        "loading": "Caricamento delle categorie... ",
        "empty": "Nessuna categoria",
        "expand": "Espandere le sottocategorie",
        "collapse": "Sottocategorie di collasso"
    },
    "tags": {
        "title": "Tag",
        "all": "Tutti",
        "loading": "Caricamento tag... ",
        "empty": "Nessun tag"
    },
    "bookmarks": {
        "title": "Segnalibri salvati",
        "empty": "Nessun contenuto salvato ancora. "
    },
    "contribute": {
        "title": "Contribuisci",
        "subtitle": "Invia i quiz per la revisione. Una volta approvati, appaiono nel feed. ",
        "subtitle_reliable": "Sei un collaboratore affidabile — i tuoi quiz vengono pubblicati immediatamente. ",
        "add": "+ Invia quiz",
        "add_first": "Invia il tuo primo quiz",
        "empty": "Non hai ancora inviato alcun contenuto. ",
        "load_failed": "Non sono riuscito a caricare i tuoi contenuti",
        "cannot_edit_approved": "I contenuti approvati possono essere modificati solo da un amministratore. ",
        "delete_confirm": "Eliminare \"{{title}}\"? ",
        "deleted": "Contenuti eliminati",
        "delete_failed": "Non è stato eliminato i contenuti",
        "edit": "Modifica",
        "delete": "Elimina",
        "form": {
            "submit_title": "Invia un quiz",
            "edit_title": "Modifica il tuo quiz",
            "submit_button": "Invia per la revisione",
            "save_button": "Modifiche ai salvataggi",
            "hint": "Il tuo quiz sarà esaminato prima che appaia nel feed. I contributori affidabili vengono pubblicati immediatamente. ",
            "success_updated": "Contenuti aggiornati con successo",
            "success_published": "Contenuti pubblicati con successo",
            "success_submitted": "Contenuti inviati per la revisione",
            "success_created": "Contenuti creati con successo",
            "success_translation": "Traduzione realizzata con successo",
            "failed": "Non sono riusciti a {{action}} contenuto",
            "action_update": "aggiornamento",
            "action_create": "crea",
            "choose_translation_language": "Scegli una lingua per la traduzione. ",
            "admin_add": "Aggiungi contenuti",
            "admin_edit": "Modifica contenuto",
            "admin_add_translation": "Aggiungi traduzione",
            "admin_add_translation_lang": "Aggiungi {{lang}} traduzione",
            "admin_create": "Crea contenuti",
            "admin_update": "Aggiornamento dei contenuti",
            "admin_create_translation": "Crea traduzione"
        }
    },
    "content_form": {
        "title": "Titolo",
        "slug": "Slug",
        "language": "Lingua",
        "difficulty": "Difficoltà (1–5)",
        "country": "Paese",
        "status": "Stato",
        "visibility": "Visibilità",
        "categories": "Categorie",
        "tags": "Tag",
        "translations": "Traduzioni",
        "translation_new": "(nuovo)",
        "translate_hint": "Traduci la domanda, le opzioni e la spiegazione. I metadati (difficoltà, categorie, tag) vengono copiati dalla fonte. ",
        "choose_language": "Scegli la lingua",
        "not_set": "Non impostato",
        "description": "Descrizione",
        "description_placeholder": "Domanda o descrizione del compito",
        "options": "Opzioni",
        "option_n": "Opzione {{n}}",
        "add_option": "+ Opzione aggiunge",
        "remove": "Rimuovere",
        "correct_answer": "Risposta corretta",
        "explanation": "Spiegazione",
        "explanation_placeholder": "Opzionale — mostrato dopo una risposta sbagliata"
    },
    "user_stats": {
        "title": "Le tue statistiche",
        "sign_in_prompt": "Accedi per vedere le tue statistiche",
        "guest_title": "Grado. Sali di livello. Scala leghe. ",
        "guest_lead": "Traccia XP, sblocca i gradi per i titoli e partecipa a leghe settimanali una volta effettuato l'accesso. ",
        "guest_perk_level": "Guadagna XP dai quiz e sale di livello. ",
        "guest_perk_rank": "Sblocca i ranghi del titolo man mano che il tuo livello cresce. ",
        "guest_perk_league": "Unisciti a gruppi settimanali e promuovi verso Leggendario. ",
        "xp": "XP",
        "streak": "Striscia",
        "best_streak": "La migliore striscia",
        "solved": "Risposto",
        "correct": "Esatto",
        "accuracy": "Accuratezza",
        "bookmarks": "Segnalibri",
        "contribute": "Contribuisci",
        "likes": "Piace",
        "language_mastered": "Padroneggiato",
        "language_learning": "Apprendimento",
        "last_7_days": "Ultimi 7 giorni",
        "days_suffix": "d",
        "no_activity": "Nessuna attività ancora",
        "weekly_league": "Lega settimanale",
        "league_tiers": "Livelli di campionato",
        "league_tiers_hint": "Livelli dal più basso al più alto. Arrivare al primo posto del proprio gruppo per promuovere; l'ultimo retrocessione. ",
        "league_position": "#{{position}} di {{total}} questa settimana",
        "view_leaderboard": "Consiglio completo",
        "how_leagues_work": "Come funziona",
        "you": "Tu"
    },
    "gamification": {
        "level": "Livello",
        "rank": "Grado",
        "streak": "Striscia",
        "daily_goals": "Obiettivi giornalieri",
        "achievements": "Risultati",
        "leaderboard": "Classifica",
        "season": "Stagione",
        "xp_to_next": "{{current}} / {{next}} XP al livello successivo",
        "weekly": "Settimanale",
        "monthly": "Questo mese",
        "overall": "Complessivo",
        "monthly_hint": "Classifica i giocatori in base all'XP classificata guadagnata durante la stagione del mese solare in corso (stessi rendimenti decrescenti delle leghe settimanali). Non un livello di lega separato. ",
        "overall_hint": "Classifica di tutti i tempi per XP totale permanente. ",
        "overall_empty": "Nessun giocatore ancora nella classifica generale. ",
        "players": "Membri",
        "full_board": "Consiglio completo",
        "player": "Membro",
        "ranked_xp": "XP classificati",
        "total_xp": "XP totale",
        "standing": "Standing",
        "zone": "Standing",
        "zone_promotion": "Promozione",
        "zone_safe": "Safe",
        "zone_relegation": "Retrocessione",
        "zone_legend": "I primi {{promo}} promuovono · I {{releg}} ultimi retrocedono a fine settimana. ",
        "unlocked": "Sbloccato",
        "achievements_error": "Non è riuscito a caricare gli obiettivi",
        "achievements_intro": "Sblocca badge mentre giochi — attività, precisione, serie di schemi, difficoltà e imparare dagli errori. ",
        "achievement_categories": {
            "activity": "Attività",
            "correct_answers": "Risposte corrette",
            "learning_from_mistakes": "Imparare dagli errori",
            "streaks": "Serie",
            "difficulty": "Difficoltà",
            "variety": "Varietà",
            "general": "Generale"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Dopo una risposta sbagliata, quel quiz può tornare più tardi per la revisione. Rispondere correttamente conta qui. "
        },
        "your_rank": "Il tuo grado",
        "around_you": "Intorno a te",
        "tooltip_total_xp": "{{xp}} XP totale",
        "tooltip_level": "Livello {{level}}",
        "weekly_waiting": "Non si può caricare il gruppo settimanale. Per favore, riprova. ",
        "weekly_ineligible": "Continua a giocare per sbloccare leghe settimanali. ",
        "achievements_progress": "{{unlocked}} / {{total}} sbloccato",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Obiettivo sbloccato: {{name}}"
        },
        "level_up": {
            "title": "Sali! ",
            "body": "Hai raggiunto il livello {{level}}",
            "continue": "Continua"
        }
    },
    "creator": {
        "rank": "Grado di Creatore",
        "xp": "Creator XP",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Contributi approvati",
        "views": "Visualizzazioni",
        "completions": "Completamento",
        "likes": "Piace",
        "bookmarks": "Segnalibri",
        "top_contribution": "Contributo principale",
        "newest_contribution": "Ultimo contributo",
        "to_next": "al grado successivo",
        "players_board": "Membri",
        "creators_board": "Collaboratori",
        "board_group": "Tipo di classifica",
        "weekly": "Settimanale",
        "monthly": "Mensile",
        "all_time": "Sempre",
        "weekly_hint": "Creatori classificati in base ai XP del creatore guadagnati questa settimana.",
        "monthly_hint": "Creatori classificati in base ai XP del creatore guadagnati questo mese.",
        "all_time_hint": "Classifica di tutti i tempi basata sugli XP del creatore.",
        "empty": "Nessun creatore sulla classifica al momento."
    },
    "profile": {
        "title": "Il mio profilo",
        "edit": {
            "title": "Modifica profilo"
        },
        "nav": {
            "label": "Account",
            "overview": "Panoramica",
            "stats": "Statistiche",
            "leagues": "Leghe",
            "edit": "Modifica profilo",
            "contribute": "Contribuisci",
            "bookmarks": "Segnalibri",
            "achievements": "Risultati",
            "leaderboards": "Classifiche",
            "browse": "Sfoglia contenuti"
        },
        "actions": {
            "back_to_home": "Torna alla home",
            "back_to_profile": "Torna al profilo",
            "edit": "Modifica profilo",
            "contribute": "Contribuisci"
        },
        "labels": {
            "initials": "Iniziali",
            "role": "Ruolo",
            "status": "Stato",
            "sign_in_method": "Metodo di accesso",
            "member_since": "Membro dal",
            "country": "Paese",
            "reliable": "Collaboratore affidabile"
        },
        "sections": {
            "account_info": "Informazioni sull'account",
            "authentication": "Autenticazione",
            "creator": "Creatore",
            "stats": "Le tue statistiche",
            "leagues": "Leghe settimanali"
        },
        "stats": {
            "title": "Statistiche",
            "subtitle": "Il tuo progresso, attività e lega settimanale a colpo d'occhio.",
            "empty": "Nessuna statistica ancora. Partecipa a qualche quiz per iniziare.",
            "periods": "Oggi e questa settimana",
            "today": "Oggi",
            "see_all": "Tutte le statistiche",
            "see_leagues": "Apri pagina leghe"
        },
        "leagues": {
            "title": "Leghe",
            "subtitle": "Il tuo livello di lega settimanale, posizione di gruppo e zona di promozione o retrocessione.",
            "your_group": "Il tuo gruppo di questa settimana",
            "see_all": "Apri leghe"
        }
    },
    "notifications": {
        "title": "Notifiche",
        "hint": "Ricevi avvisi sulla tua serie vincente, posizione in lega e contenuti — anche quando Procrastiq è chiuso.",
        "enable": "Abilita notifiche",
        "disable": "Disattiva su questo dispositivo",
        "enabled": "Notifiche abilitate",
        "disabled": "Notifiche disattivate su questo dispositivo",
        "enable_failed": "Impossibile abilitare notifiche",
        "disable_failed": "Impossibile disattivare notifiche",
        "prefs_failed": "Impossibile salvare preferenze",
        "unsupported": "Le notifiche push non sono supportate in questo browser.",
        "pref_ranking": "Lega e classifica",
        "pref_streak": "Serie vincente",
        "pref_reactions": "Reazioni ai miei contenuti",
        "pref_approved": "Approvazione dei contenuti"
    },
    "games": {
        "challenge_friend": "Challenge a friend",
        "survival_mode": "Survival",
        "challenges_inbox": "Challenges",
        "view_inbox": "View inbox",
        "pick_friend": "Pick a friend",
        "random_opponent": "Random opponent",
        "search_users": "Search by name…",
        "search_error": "Could not search users",
        "selected": "Selected",
        "selected_opponent": "Selected player",
        "pick_opponent": "Pick an opponent first",
        "random_hint": "We'll match you with an active player.",
        "any_category": "Any category",
        "category_optional": "Category (optional)",
        "start_challenge": "Send challenge",
        "challenge_created": "Challenge sent!",
        "create_error": "Could not create challenge",
        "challenge": "Challenge",
        "open": "Open",
        "new_challenge": "New challenge",
        "start_playing": "Start playing",
        "accept_play": "Accept & play",
        "decline": "Decline",
        "decline_error": "Could not decline challenge",
        "your_result": "Your result",
        "opponent_result": "Opponent",
        "waiting_opponent": "Waiting for your opponent to finish…",
        "score_line": "{{correct}}/{{total}} correct · {{time}}",
        "you_won": "You won!",
        "you_lost": "You lost",
        "draw": "It's a draw",
        "submitting": "Submitting answers…",
        "submit_error": "Could not submit challenge",
        "load_error": "Could not load",
        "not_found": "Challenge not found",
        "no_challenges": "No challenges yet",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "player": "Player",
        "filter": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "all": "All"
        },
        "status": {
            "pending": "Pending",
            "in_progress": "In progress",
            "completed": "Completed",
            "declined": "Declined",
            "expired": "Expired"
        },
        "question_progress": "Question {{current}} / {{total}}",
        "time_left": "{{seconds}}s",
        "elapsed_time": "Time {{time}}",
        "overall_time": "Total time",
        "total_time_left": "Total {{seconds}}s",
        "no_options": "No answer options for this question",
        "survival_leaderboard": "Survival leaderboard",
        "survival_leaderboard_hint": "Best survival run per player in the selected period.",
        "survival_empty": "No survival scores yet — be the first!",
        "play_survival": "Play Survival",
        "current_score": "Score: {{score}}",
        "game_over": "Game over",
        "final_score": "You scored {{score}}",
        "personal_best": "Personal best: {{score}}",
        "daily_rank": "Daily rank: #{{rank}}",
        "weekly_rank": "Weekly rank: #{{rank}}",
        "play_again": "Play again",
        "survival_start_error": "Could not start survival run",
        "survival_error": "Survival error",
        "daily": "Daily",
        "weekly": "Weekly",
        "all_time": "All time",
        "score": "Score",
        "challenge_user": "Challenge {{name}}",
        "login_to_challenge": "Log in to challenge this player",
        "profile_error": "Could not load profile",
        "profile_not_found": "Player not found",
        "profile": "Profile",
        "notifications": "Notifications",
        "mark_all_read": "Mark all read",
        "no_notifications": "No notifications",
        "blocked_users": "Blocked players",
        "blocked_hint": "Blocked players cannot challenge you.",
        "no_blocked": "You haven't blocked anyone.",
        "unblock": "Unblock",
        "unblocked": "Player unblocked",
        "unblock_error": "Could not unblock player",
        "blocked_load_error": "Could not load blocked players",
        "survival_howto": "Rispondi correttamente il più a lungo possibile. Hai 20 secondi per domanda. Un errore viene perdonato: il secondo termina la partita. Il punteggio è il numero di risposte giuste.",
        "challenge_howto": "Dieci domande, 20 secondi ciascuna. Vincono più risposte corrette e un tempo più rapido. Vedrai il risultato dell'avversario quando avrete finito entrambi.",
        "continue": "Continua",
        "survival_reserve": "Riserva: {{count}}",
        "survival_second_chance": "Seconda possibilità!",
        "guest_teaser": "Log in to challenge friends and climb Survival ranks."
    }
};
